import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import useFetch, { ExtendedCacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { EquipmentKits } from "./type.ts";

const useEquipmentKits = () => {

  const fetch = useFetch();

  const { data, isLoading, isError, error } = useQuery<
    EquipmentKits[] | null,
    Error,
    EquipmentKits[]
  >({
    queryKey: ["equipment-kits"],
    queryFn: () =>
      fetch<EquipmentKits[]>(`${Urls.EquipmentKits}`, {
        method: "GET",
      }),
    gcTime: ExtendedCacheTime,
    staleTime: ExtendedCacheTime,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting equipment kits");
    }
  }, [error?.message, isError]);

  return {
    kits: data,
    isFetching: isLoading,
  };
};

export default useEquipmentKits;
